import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import LoadingPage from "../../Loader";

import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';

const Events = () => {
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getData } = useAuth();

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const leavesResponse = await getData("proccess.php", "event_V2");
        if (leavesResponse.success && Array.isArray(leavesResponse.data)) {
          const currentDate = new Date(); // Current date and time
          
          // Filter events: only featured events with startDate on or after current date
          // Then sort by startDate in ascending order and limit to 5
          const filteredAndSortedLeaves = leavesResponse.data
            .filter((leave) => {
              const endDate = leave.endDate ? new Date(leave.endDate) : new Date(leave.startDate);
              return leave.isFeafured === 'yes' && endDate >= currentDate;
            })
            .sort((a, b) => {
              const dateA = new Date(a.startDate);
              const dateB = new Date(b.startDate);
              return dateA - dateB; // Ascending order (earliest first)
            })
            .slice(0, 50); // Show only top 50 upcoming events

          setLeaves(filteredAndSortedLeaves);
        } else {
          console.error("Events response error:", leavesResponse.message || "No data");
          setLeaves([]);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to load events. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [getData]);

  // Format date function to make dates more readable
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <Box minHeight="100vh" display="flex" justifyContent="center" alignItems="center">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box minHeight="auto" width="100%" bgcolor="transparent" paddingBottom={'1rem'}>
      <Typography variant="h4" color="black" align="center" sx={{ padding: 2 }}>
        Upcoming Events
      </Typography>
      {leaves.length === 0 ? (
        <Typography color="black" align="center" sx={{ padding: 2 }}>
          No featured upcoming events available at the moment.
        </Typography>
      ) : (
        leaves.map((leave, index) => (
          <Box
            key={index}
            sx={{ padding: 2, backgroundColor: "#e7f5f8", margin: 2, borderRadius: 1 }}
            boxShadow={2}
          >
            <Box>
              <Box display={'flex'} alignItems={'start'} gap={'1rem'}>
                <TodayOutlinedIcon />
                <Typography variant="h6" color="#22aa38ff" fontWeight={700}>
                  {leave.title || "Untitled"}
                </Typography>
              </Box>
              
              <Typography variant="body1" margin={'.5rem 0'}>
                {leave.description && leave.description.length > 200 
                  ? leave.description.substring(0, 200) + "..." 
                  : leave.description || "No description available."}
              </Typography>
            </Box>
            
            {/* Event Image */}
            {leave.image && (
              <Box
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '10px',
                  overflow: 'hidden',
                  marginY: 2
                }}
              >
                <img
                  src={`https://mindsinaction.com.na/assets/media/pictures/${leave.image}`}
                  alt={leave.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </Box>
            )}

            {leave.showDate === "yes" ?
              (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '.1rem dashed gray',
                    padding: '1rem 0'
                  }}
                >
                  {leave.startDate && (
                    <Typography variant="body1" color="gray">
                      <Typography component="span" fontWeight={700}>Starts: </Typography>
                      {formatDate(leave.startDate)}
                    </Typography>
                  )}
                  {leave.endDate && (
                    <Typography variant="body1" color="#f15959ff">
                      <Typography component="span" fontWeight={700}>Ends: </Typography>
                      {formatDate(leave.endDate)}
                    </Typography>
                  )}
                  
                </Box>
              ):(
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '.1rem dashed gray',
                    padding: '1rem 0',
                  }}
                >
                </Box>
              )
            }
            
            
            {/* <Typography variant="body2" color="#c8cac8ff" sx={{ marginTop: 1 }}>
              Posted: {formatDate(leave.dateCreated)}
            </Typography> */}
          </Box>
        ))
      )}
    </Box>
  );
};

export default Events;